import type { Margins } from "#public"

/**
 * Rotate margins 90° clockwise — the inverse of {@link RotateMarginsLeft}.
 *
 * Mirrors Python `MarginMeasureSet.rotate_fields(reverse=True)`.
 */
export const RotateMarginsRight = <T>(p: Margins<T>): Margins<T> => ({
  top: p.left,
  right: p.top,
  bottom: p.right,
  left: p.bottom,
})
